/**
 * Onboarding Step Registry
 *
 * Maps step IDs to lazy-loaded component factories.
 * Adding a new onboarding step only requires an entry here and in
 * the vertical's backend onboarding config — no static route needed.
 */
import { lazy, type ComponentType } from 'react'

type StepFactory = () => Promise<{ default: ComponentType<Record<string, unknown>> }>

export const STEP_REGISTRY: Record<string, StepFactory> = {
  set_institution_details: () => import('./InstitutionDetailsStep'),
  submit_verification: () => import('./VerificationStep'),
  import_entities: () => import('./ImportEntitiesStep'),
  request_whatsapp: () => import('./WhatsAppStep'),
  set_paybill: () => import('./PaybillStep'),
  invite_team: () => import('./InviteTeamStep'),
  link_auth_methods: () => import('./LinkAuthMethodsStep'),
  choose_product: () => import('./ChooseProductStep'),
  // Going live is not a form: with a bank step it happens when the first
  // payment reaches the connected account (the "Get paid" step watches for
  // it); without one, once LipaFlow has verified the organisation.
  go_live: () => import('./GoLiveStep'),
}

/**
 * Lazy component for each registered step (used by StepLoader).
 */
export const STEP_COMPONENTS: Record<string, ComponentType<Record<string, unknown>>> = Object.fromEntries(
  Object.entries(STEP_REGISTRY).map(([id, factory]) => [id, lazy(factory)])
)
